import List from 'src/components/UCA/List';
import ListItem from 'src/components/UCA/ListItem';
import { SUBSECTION } from 'src/data/ProcessingRequests/constant';

export default function Section() {
  return (
    <div className="list-none p-0 px-10 pt-4">
      <List prefix="A">
        <ListItem prefix="">{SUBSECTION.context}</ListItem>
      </List>
    </div>
  );
}
